import { FACTORY_BRICK_SIZE_OPTIONS } from './factoryBrickSizes';

const S = Object.fromEntries(FACTORY_BRICK_SIZE_OPTIONS.map((o) => [o.value, o.value]));

/**
 * Common brick / paver types for Tanzania factories — quick setup templates.
 * Owner can edit prices and recipe later under Production → Brick & tile types.
 */
export const FACTORY_BRICK_TYPE_TEMPLATES = [
  {
    id: 'solid-6',
    name: 'Solid brick 6 inch',
    code: 'SOLID-6',
    sizeLabel: S['230×110×75 mm'],
    unit: 'pieces',
  },
  {
    id: 'hollow-6',
    name: 'Hollow brick 6 inch',
    code: 'HOLLOW-6',
    sizeLabel: S['230×110×75 mm (hollow)'],
    unit: 'pieces',
  },
  {
    id: 'solid-5',
    name: 'Solid brick 5 inch',
    code: 'SOLID-5',
    sizeLabel: S['230×110×65 mm'],
    unit: 'pieces',
  },
  {
    id: 'hollow-5',
    name: 'Hollow brick 5 inch',
    code: 'HOLLOW-5',
    sizeLabel: S['230×110×65 mm (hollow)'],
    unit: 'pieces',
  },
  {
    id: 'maxi',
    name: 'Maxi brick',
    code: 'MAXI',
    sizeLabel: S['290×140×90 mm'],
    unit: 'pieces',
  },
  {
    id: 'paver',
    name: 'Paver / tile',
    code: 'PAVER',
    sizeLabel: S['200×100×80 mm'],
    unit: 'pieces',
  },
  {
    id: 'curb',
    name: 'Curb stone',
    code: 'CURB',
    sizeLabel: S['Road curb stone'],
    unit: 'pieces',
  },
];
